export default __webpack_public_path__ + "static/media/survey-concept.34e1d94b.png";